import api from '@/services/api.service';
import type { SalesAnalyticsFilterParams } from '@/services/salesAnalytics.service';

export interface SalesAnalyticsSavedView {
  id: string;
  name: string;
  filters: SalesAnalyticsFilterParams;
  created_at: string;
}

const PREFS_KEY = 'sales_analytics_saved_views';

function parsePrefs(raw: string | Record<string, unknown> | null | undefined): Record<string, unknown> {
  if (!raw) return {};
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw) as Record<string, unknown>;
    } catch {
      return {};
    }
  }
  return raw;
}

export function readSavedViewsFromUser(
  user: { preferences?: string | Record<string, unknown> | null } | null
): SalesAnalyticsSavedView[] {
  const prefs = parsePrefs(user?.preferences ?? null);
  const raw = prefs[PREFS_KEY];
  if (!Array.isArray(raw)) return [];
  return raw.filter(
    (v): v is SalesAnalyticsSavedView =>
      Boolean(v && typeof v === 'object' && typeof (v as SalesAnalyticsSavedView).id === 'string')
  );
}

export async function persistSavedViews(
  userId: string,
  currentPrefs: Record<string, unknown>,
  views: SalesAnalyticsSavedView[]
): Promise<void> {
  const next = { ...currentPrefs, [PREFS_KEY]: views };
  await api.put(`/users/${userId}/preferences`, next);
}

export function createSavedView(name: string, filters: SalesAnalyticsFilterParams): SalesAnalyticsSavedView {
  return {
    id: `view-${Date.now()}`,
    name: name.trim(),
    filters: { ...filters },
    created_at: new Date().toISOString(),
  };
}
